module.exports = __webpack_public_path__ + "static/media/3-HubDistribucion.353b9712.jpg";